<template>
  <div>
    <div v-if="formStep == 0">
      <section class="section--title-page">
        <h3 class="colored-icon">{{
          __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.part1Title") }}</h3>
      </section>
      <div v-if="segmentation_mode != 1">
        <div v-if="segmentation_mode == 0">
          <label>Scegli segmentazione</label>
          <select class="form-control" v-model="segmentation_id">
            <option v-for="segmentation in segmentations" :value="segmentation.id" v-bind:key="segmentation.id">
              {{ segmentation.name }}
            </option>
          </select>
        </div>
        <div v-if="segmentation_mode == -1">
          <div v-if="default_segmentation_type == 0">
            <div>
              <div>
                <label>{{ __("forms.KPISegments.typology") }}</label>
                <select class="form-control" v-model="typology_choose" @change="changeSettingsSegmentation()">
                  <option value="number" v-if="filter_segmentation_typology.indexOf('number') >= 0">
                    {{ __("forms.KPISegments.number_segmentation") }}
                  </option>
                  <option value="date" v-if="filter_segmentation_typology.indexOf('date') >= 0">
                    {{ __("forms.KPISegments.date_segmentation") }}
                  </option>
                  <option value="text" v-if="filter_segmentation_typology.indexOf('text') >= 0">
                    {{ __("forms.KPISegments.text_segmentation") }}
                  </option>
                  <option v-if="enable_segmentation_standard" value="standard">
                    {{ __("forms.KPISegments.standard_segmentation") }}
                  </option>
                </select>
              </div>
              <div v-if="typology_choose != 'standard'">
                <div v-if="typology_choose == 'number'">
                  <label>{{ __("forms.KPISegments.calculation_mode") }}</label>
                  <select class="form-control" v-model="type_segments"
                    @change="setAutomaticDetectionSegmentDirection()">
                    <option value="line">{{ __("forms.KPISegments.calculation_line") }}</option>
                    <option value="step">{{ __("forms.KPISegments.calculation_step") }}</option>
                  </select>
                </div>
                <div v-if="segmentation_calculation == -1">
                  <div v-if="typology_choose == 'number'">
                    <label>{{ __("forms.KPISegments.calculation_performance") }}</label>
                    <select class="form-control" v-model="automatic_percentage_calculation"
                      @change="setAutomaticDetectionSegmentDirection()">
                      <option v-if="type_segments === 'line'" value="1">{{
                        __("forms.KPISegments.automatic_performance") }}</option>
                      <option value="0">{{ __("forms.KPISegments.manual_performance") }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>


            <div class="form-group" v-if="enable_segmentation_standard && typology_choose == 'standard'">
              <label>{{ __("forms.KPISegments.select_standard_segmentation") }}</label>
              <select v-model="standardSegmentationId" class="form-control" @change="setConfigStandard()">
                <option v-for="standardSeg in standard_segmentations" :value="standardSeg.id"
                  v-bind:key="standardSeg.id">
                  {{ standardSeg.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div v-if="!auto_detect_segmentation_direction">
          <label>{{ __("forms.KPISegments.direction_segmentation") }}</label>
          <select class="form-control" v-model="segmentation_direction">
            <option value="increment">{{ __("forms.KPISegments.direction_segmentation_increment") }}</option>
            <option value="decrement">{{ __("forms.KPISegments.direction_segmentation_decrement") }}</option>
          </select>
        </div>
      </div>
      <div v-else>
        <div class="alert alert-warning">
          {{ __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.noSegmentationConfigRequired")
          }}
        </div>
      </div>
      <hr>
      <button class="btn btn--blue" @click="goToStep1()">{{ __("forms.KPISegments.next") }}</button>

    </div>
    <div v-if="formStep == 1">
      <section class="section--title-page">
        <h3 class="colored-icon">{{
          __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.part2Title") }}</h3>
      </section>
      <div class="form-group">
        <label>{{ __("forms.KPIS.name") }}</label>
        <input type="text" v-model="nameKpi" class="form-control">
      </div>
      <div class="form-group" v-if="show_measures_and_formulas">
        <label>{{ __("forms.KPIS.measuers_and_formulas") }}</label>
        <textarea v-model="measures_and_formulas" class="form-control" style="height: 200px !important;"></textarea>
      </div>
      <div class="form-group" v-if="show_unit_measure">
        <label>{{ __("forms.KPIS.unit_measure") }}</label>
        <input type="text" v-model="unit_measure" class="form-control" required >
      </div>
      <div class='form-group'
        v-if="kpi_require_file_on_consumptive == 'kpi_require_file_on_consumptive_choose_on_chart'">
        <label>{{ __("forms.EvaluationChart.questions.questions_setting.question12.showKpiRequireFileOnConsumptive")
          }}</label>
        <select class="form-control" v-model="kpiRequireFileOnConsumptive">
          <option value='0'>
            <label>
              {{
                __("forms.EvaluationChart.questions.questions_setting.question12.defaultKpiRequireFileOnConsumptive_not_required")
              }}
            </label>
          </option>
          <option value='1'>
            <label>
              {{
                __("forms.EvaluationChart.questions.questions_setting.question12.defaultKpiRequireFileOnConsumptive_required")
              }}
            </label>
          </option>
        </select>
      </div>

      <div class="form-group" v-if="show_classification_on_create_kpi">
        <label>{{ __("forms.KPIS.classification") }}</label>
        <select class="form-control" v-model="classification_id" :required="required_classification_on_create_kpi">
          <option value="" v-if="!required_classification_on_create_kpi">
            {{ __("forms.EvaluationChart.questions.questions_setting.question12.no_classification") }}
          </option>
          <optgroup :label="type.name" v-for="type in classification_types" v-bind:key="type.id">
            <option v-for="classification in kpi_classifications" v-if="classification.type == type.id"
              :value="classification.id" v-bind:key="classification.id">
              {{ classification.name }}
            </option>
          </optgroup>
          <option v-for="classification in kpi_classifications" v-if="classification.type == 0"
            :value="classification.id" v-bind:key="classification.id">
            {{ classification.name }}
          </option>
        </select>
      </div>

      <div class="form-group" v-if="show_esg_on_create_kpi">
        <label>{{ __("forms.KPIS.esgList") }}</label>
        <multiselect v-model="esg_ids" placeholder="Search a tag" label="identifiable_name" track-by="id"
          :options="kpi_esgs" :multiple="true" :taggable="true"></multiselect>
      </div>

      <div class="form-group" v-if="show_categories_on_create_kpi">
        <label>{{ __("forms.EvaluationChart.questions.questions_setting.question12.tableKPI.categories") }}</label>
        <multiselect v-model="category_ids" placeholder="Search a category" label="identifiable_name" track-by="id"
          :options="kpi_categories" :multiple="true" :taggable="true"></multiselect>
      </div>

      <div class="form-group"
        v-if="typology == 'number' && automatic_percentage_calculation == 1 && default_segmentation_id == 0 && type_segments == 'line'">
        <label>{{ __("forms.KPIS.target") }}</label>
        <input type="number" v-model="target" class="form-control" step="0.01">
      </div>
      <div class="alert alert-warning"
        v-if="show_prize_value && prize_mode == 'weight_percentage' && remaining_percent_for_complete != 0">
        <div v-if="remaining_percent_for_complete > 0">
          {{ __("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.weight_sum_below_100") }}
          {{ remaining_percent_for_complete }} %
        </div>
        <div v-else>
          {{ __("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.weight_sum_above_100") }}
          {{ remaining_percent_for_complete }} %
        </div>
      </div>
      <div class="form-group" v-if="show_prize_value">
        <label v-if="prize_mode == 'ral_percentage'">{{
          __("forms.EvaluationChart.questions.questions_setting.question12.prizeNames.ral_percentage") }}</label>
        <label v-if="prize_mode == 'fixed_amount'">{{
          __("forms.EvaluationChart.questions.questions_setting.question12.prizeNames.fixed_amount") }}</label>
        <label v-if="prize_mode == 'weight_percentage'">{{
          __("forms.EvaluationChart.questions.questions_setting.question12.prizeNames.weight_percentage") }}</label>
        <input type="number" v-model="prize_value" class="form-control" step="0.01"
          @change="changeValuePercentRemaning($event)">
      </div>
      <div class="form-group">
        <label>{{ __("forms.KPIPeople.indicator") }}</label>
        <select v-model="indicator" class="form-control">
          <option v-if="indicators_available.length < 1">---</option>
          <option v-for="indicator in indicators_available" v-if="indicators_preset.includes(indicator['slug_name'])"
            :value="indicator['slug_name']" v-bind:key="indicator['slug_name']">
            {{ indicator.name }}
          </option>
        </select>
      </div>
      <div class="buildSegmentation" v-if="this.segmentation_mode == -1">
        <label>{{ __("forms.KPIPeople.build_segmentation") }}</label>
        <table class="table">
          <thead>
            <tr>
              <th v-if="!checkbox_number_goals"></th>
              <th v-if="automatic_percentage_calculation == 0">{{ __("forms.KPISegments.manualThreshold") }}</th>
              <th v-if="show_percent_performance_on_create_kpi">
                {{ __("forms.KPISegments.threshold") }}
              </th>
              <th v-else></th>
              <th v-if="show_percent_reaching_on_create_kpi">
                {{ __("forms.KPISegments.percentage") }}
              </th>
              <th v-else></th>
              <th>{{ __("forms.KPISegments.note") }}</th>
              <th>{{ __("forms.KPISegments.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(goalRow, index) in segmentation_goals" v-bind:key="index">
              <td v-if="!checkbox_number_goals">
                <button class="btn btn--red" @click="rmRowGoal(index)">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
              <td v-if="automatic_percentage_calculation == 0">

                <div v-if="typology_choose !== 'standard'">
                  <input v-if="typology == 'number'" type="number" class="form-control" step="0.01"
                    v-model="goalRow['manual_threshold']">
                  <input v-if="typology == 'date'" type="date" class="form-control"
                    v-model="goalRow['date_manual_threshold']">
                  <input v-if="typology == 'text'" type="text" class="form-control"
                    v-model="goalRow['text_manual_threshold']">
                </div>
                <div v-else>
                  <span v-if="typology == 'number'">{{ goalRow['enchantedNumber'] }}</span>
                  <span v-if="typology == 'date'">{{ goalRow['enchantedDate'] }}</span>
                  <span v-if="typology == 'text'">{{ goalRow['text_manual_threshold'] }}</span>
                </div>
              </td>

              <td v-if="!show_percent_performance_on_create_kpi"></td>
              <td v-else-if="automatic_percentage_calculation >= 1">
                <input type="number" class="form-control" step="0.01" v-model="goalRow['treshold']"
                  v-if="show_percent_performance_on_create_kpi">
              </td>
              <td v-else>
                {{ goalRow['treshold'] }}
              </td>
              <td v-if="!show_percent_reaching_on_create_kpi"></td>
              <td v-else-if="!block_edit_reparted_prize">
                <input type="number" class="form-control" step="0.01" v-model="goalRow['percentage']">
              </td>
              <td v-else>
                {{ goalRow['percentage'] }}
              </td>
              <td>{{ goalRow.note }}</td>
              <td>
                <input type="text" class="form-control" v-model="goalRow.description">
              </td>

            </tr>
          </tbody>
        </table>
        <div v-if="
          checkbox_number_goals &&
          automatic_percentage_calculation == 0 &&
          segmentation_goals.length == 3 &&
          (standardSegmentationId <= 0 && typology == 'number')
        ">
          <button type="button" @click="calculateThresholds()" class="btn btn--blue">
            <i class="fas fa-cogs"></i> {{ __("forms.KPISegments.calculate_%_performance") }}
          </button>
        </div>
        <hr>
        <button type="button" @click="addRowGoal" class="btn btn--blue" v-if="!checkbox_number_goals">
          {{ __("forms.KPIS.add_goal") }}
        </button>
      </div>

      <div style="margin-top: 10px">
        <button class="btn btn--green" @click="addTarget()">
          <i class="fas fa-plus"></i>
          {{ __("forms.KPIS.add_kpi") }}
        </button>
      </div>
    </div>
    <div v-if="formStep == 2">
      <section class="section--title-page">
        <h3 class="colored-icon">{{
          __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.part3Title") }}</h3>
      </section>
      <div class="row">
        <div class="col-4">
          <label class="text-primary mb-2">{{
            __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.condition_filters") }}</label>

          <div class="form-group position-relative">
            <label>{{
              __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.share_first_filter_type")
            }}</label>
            <select class="form-control" v-model="share_first_filter_type" @change="kpiShareGetDataForSecondFilter()">
              <option value=''>---</option>
              <option value='responsible'>{{
                __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.responsible_filter") }}
              </option>
              <option value='role'>{{
                __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.role_filter") }}</option>
              <option value='organizational_unit'>{{
                __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.organizational_unit_filter")
              }}</option>
              <option value='company'>{{
                __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.company_filter") }}
              </option>
              <option value='headquarter'>{{
                __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.headquarter_filter") }}
              </option>
            </select>
            <div v-if="shareFlag" class="position-absolute load_spinner_absolute"><i
                class="fas fa-spinner fa-spin ml-2"></i>
            </div>
          </div>

          <div class="form-group">
            <label>{{ __("misc.choose") }}</label>
            <select class="form-control" v-model="kpi_share_second_filter_id" @change="resetPaginationPages($event)">
              <option value="">...</option>
              <option v-for="s_filter in share_people_unselected_ids" :value="s_filter.id">
                {{ s_filter.value }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.name_filter")
              }}</label>
            <input @change="resetPaginationPages()" type="text" class="form-control" v-model="share_text_filter">
          </div>

        </div>
        <div class="col-4">
          <label class="text-primary mb-2">
            {{ __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.unselected_people") }}
            <a v-if="people_unselected_pagination.data != undefined && people_unselected_pagination.data.length > 0"
              class="page-link" aria-label="addAll" @click="addAllPageBeneficiaries()">
              <i class="fal fa-plus-circle"></i> {{
                __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.add_all_page") }}
            </a>
          </label>

          <div v-if="people_unselected_pagination.total > 0">
            <ul>
              <li class="d-flex align-items-center" v-for="person in people_unselected_pagination.data">
                <a href="#" @click="kpiShareAddSelectedPerson(person.id)">
                  <i class="fas fa-arrow-right colored-icon"></i>
                </a>
                <span class="ml-2">{{ person.fullName }}</span>
              </li>
            </ul>
            <nav aria-label="Page navigation">
              <ul class="pagination justify-content-start mt-3">
                <li class="page-item">
                  <button class="page-link" aria-label="First Page" @click="goToFirstPage">
                    <i class="fa fa-chevron-double-left"></i>
                  </button>
                </li>
                <li class="page-item">
                  <button class="page-link" aria-label="Previous Page" @click="goToPreviousPage">
                    <i class="fa fa-chevron-left"></i>
                  </button>
                </li>
                <li class="page-item disabled">
                  <span class="page-link">
                    {{ currentPage }} / {{ totalPages }}
                  </span>
                </li>
                <li class="page-item">
                  <button class="page-link" aria-label="Next Page" @click="goToNextPage">
                    <i class="fa fa-chevron-right"></i>
                  </button>
                </li>
                <li class="page-item">
                  <button class="page-link" aria-label="Last Page" @click="goToLastPage">
                    <i class="fa fa-chevron-double-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>

        </div>
        <div class="col-4">
          <label class="text-primary mb-2">
            <label>{{ __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.selected_people") }}
              ( {{ share_people_selected_array.length }} )
              <a v-if="share_people_selected_array.filter(item => item.id !== person_id).length" class="page-link"
                aria-label="addAll" @click="removeAllBeneficiaries()">
                <i class="fal fa-minus-circle"></i> {{
                  __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.remove_all") }}
              </a>
            </label>
          </label>
          <ul>
            <li class="d-flex align-items-center" v-for="person in share_people_selected_array">

              <a v-if="person.id != person_id" href="#" @click="kpiShareRemovedSelectedPerson(person.id)">
                <i class="fas fa-trash red-colored-icon"></i>
              </a>
              <i v-else class="fas fa-user colored-icon"></i>
              <span class="ml-2">{{ person.fullName }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div style="margin-top: 10px" class="form-buttons clear float-right">
        <button class="btn btn--green" @click="kpiShareStorePeople()">
          <i class="fas fa-plus"></i>
          {{ __("forms.KPIS.add_kpi") }}
        </button>
      </div>
    </div>
    <div v-if="formStep == 3">
      <section class="section--title-page">
        <h3 class="colored-icon">{{
          __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.part4Title") }}</h3>
      </section>
      <div class="alert alert-warning" v-if="showAlertSumWeight100Present">
        <label>
          {{
            __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.alertAlreadyPresentSumWeight100_1")
          }}
        </label>
        <br>
        <label>
          {{
            __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.alertAlreadyPresentSumWeight100_2")
          }}
        </label>
      </div>
      <div class="row">
        <div class="col-2">
          <div class="form-group">

            <label>{{ __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.setPrizeValueToAll")
              }}</label>
            <input v-model="shareKpiMassivePrizeValue" class="form-control" type="number" min="0"
              @change="changeShareKpiMassivePrizeValue()">
          </div>

        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>{{ __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.selected_people") }}
            </th>
            <th>{{
              __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.sumWeightsCurrentlyAssigned")
            }}</th>
            <th>{{ __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.newWeightsToAssign") }}
            </th>
            <th>{{ __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.remainWeightToAssign")
              }}</th>
            <th>{{ __("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.finalSum") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(combo) in share_people_selected_weight_array">

            <td class="d-flex align-items-center">
              <a v-if=!combo.can_be_inserted href="#" @click="removeShareKpiPersonAt100(combo.person_id)">
                <i class="fas fa-trash red-colored-icon"></i>
              </a>
              <span class="ml-2">{{ combo.fullName }}</span>
            </td>
            <td>{{ combo.currentSumWeight }}</td>

            <td v-if=combo.can_be_inserted>
              <input type="number" min="0" class="form-control" v-model="combo.currentWeightSet"
                @change="changeShareKpiPrizeValue($event, combo.person_id)">
            </td>
            <td v-else></td>

            <td v-if=combo.can_be_inserted>{{ combo.remainWeightToAssign }} </td>
            <td v-else></td>

            <td v-if=combo.can_be_inserted>{{ combo.currentWeightPlusNewSet }}</td>
            <td v-else></td>
          </tr>

        </tbody>
      </table>
      <div style="margin-top: 10px" class="form-buttons clear float-right">
        <button class="btn btn--green" @click="openSubmitPopup()">
          <i class="fas fa-plus"></i>
          {{ __("misc.save") }}
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  mounted() {

    this.formStep = 0;
    this.segmentation_id = this.default_segmentation_id;
    this.segmentation_direction = this.default_segmentation_direction;

    if (this.segmentation_calculation != -1) {
      this.automatic_percentage_calculation = this.segmentation_calculation
    }
    if (this.default_segmentation_type != 0) {
      this.type_segments = this.default_segmentation_type;
    }

    this.segmentation_goals = this.static_goals_array;
  },
  props: {
    kpi_group_id: {
      type: Number,
      required: true
    },
    is_admin: {
      type: Boolean,
      required: true
    },
    open_in_chart: {
      type: Boolean,
      required: false,
      default: true
    },
    enable_segmentation_standard: {
      type: Boolean,
      required: false,
      default: true
    },
    approve_kpi: {
      type: Boolean,
      required: true,
    },

    default_segmentation_type: {
      type: String,
      required: true,
    },
    prize_mode: {
      type: String,
      required: true
    },
    person_id: {
      type: Number,
      required: true
    },
    question_survey_id: {
      type: Number,
      required: true
    },
    kpi_incentive_plan_id: {
      type: Number,
      required: true
    },
    default_segmentation_id: {
      type: Number,
      required: false,
      default: null
    },
    default_segmentation_direction: {
      type: String,
      required: true
    },
    segmentation_mode: {
      type: Number,
      required: true
    },
    segmentation_calculation: {
      type: Number,
      required: true
    },
    block_edit_reparted_prize: {
      type: Boolean,
      required: true
    },
    checkbox_number_goals: {
      type: Boolean,
      required: true
    },
    show_percent_performance_on_create_kpi: {
      type: Boolean,
      required: true
    },
    show_percent_reaching_on_create_kpi: {
      type: Boolean,
      required: true
    },
    required_classification_on_create_kpi: {
      type: Boolean,
      required: true
    },
    kpi_require_file_on_consumptive: {
      type: String,
      required: true
    },
    show_classification_on_create_kpi: {
      type: Boolean,
      required: true
    },
    show_esg_on_create_kpi: {
      type: Boolean,
      required: true
    },
    shared_kpi_beneficiary_filter: {
      type: Boolean,
      required: true
    },
    show_categories_on_create_kpi: {
      type: Boolean,
      required: true
    },
    show_prize_value: {
      type: Boolean,
      required: true
    },
    auto_distribution_weights: {
      type: Boolean,
      required: true
    },
    show_unit_measure: {
      type: Boolean,
      required: true
    },
    show_measures_and_formulas: {
      type: Boolean,
      required: true
    },
    permission_share_created_kpi: {
      type: Number,
      required: true
    },
    indicators_preset: {
      type: Array,
      required: false,
      default: []
    },
    standard_segmentations: {
      type: Array,
      required: false,
      default: []
    },
    segmentations: {
      type: Array,
      required: true
    },
    kpi_classifications: {
      type: Array,
      required: true
    },
    classification_types: {
      type: Array,
      required: true
    },
    kpi_esgs: {
      type: Array,
      required: true
    },
    kpi_categories: {
      type: Array,
      required: true
    },
    indicators_available: {
      type: Array,
      required: true
    },
    static_goals_array: {
      type: Array,
      required: true,
    },
    filter_segmentation_typology: {
      type: Array,
      required: true,
    },
    all_people: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formStep: 0,
      standardSegmentationId: 0,
      typology_choose: null,
      typology: "number", //date - text

      temp_text_goals: {},

      nameKpi: null,
      classification_id: null,
      esg_ids: [],
      category_ids: [],
      target: 0,
      measures_and_formulas: null,
      unit_measure: null,
      prize_value: 0,
      remaining_percent_for_complete: 0,
      indicator: null,
      segmentation_id: 0,
      segmentation_direction: "increment",
      segmentation_goals: [],
      automatic_percentage_calculation: 1,
      type_segments: "line",
      //
      userUrl: (this.is_admin) ? '' : '-user',
      prizeValueLabel: "",
      auto_detect_segmentation_direction: true,
      addKpiFormParams: {},

      //Share kpi created
      share_first_filter_type: null,
      kpi_share_second_filter_id: null,

      //array with people ids
      share_people_unselected_ids: [],
      share_people_selected_ids: [],
      shareFlag: false,

      currentPage: 1,
      totalPages: 0,

      //Return array value from get-api share people filtered
      people_unselected_pagination: [],

      share_people_selected_array: [],
      page_number_selectable_people: 1,
      share_text_filter: "",

      //Step 3 combo array person | weight
      share_people_selected_weight_array: [],
      shareKpiMassivePrizeValue: 0,
      showAlertSumWeight100Present: false,

      kpiRequireFileOnConsumptive: null,

    }
  },

  methods: {

    goToStep1() {

      if ((this.standardSegmentationId == null || this.standardSegmentationId == 0) && this.typology_choose == "standard") {
        return;
      }

      if (!this.auto_detect_segmentation_direction && (this.segmentation_direction == undefined || this.segmentation_direction == '')) {
        return;
      }
      if (this.default_segmentation_id > 0) {
        //read info about this segmentation, set a default target value,
        //read steps abouts this segmentation and read the scalar value associated at 100
        this.getSegmentationTargetGoal(this.default_segmentation_id);
      }
      this.formStep = 1;
      this.getRemaningPercentWeigthTo100(this.prize_value);

    },

    changeValuePercentRemaning(event) {
      this.getRemaningPercentWeigthTo100(event.target.value);
    },
    getRemaningPercentWeigthTo100(currentWeight) {


      if (this.prize_mode !== 'weight_percentage') {
        return;
      }

      if (currentWeight === "") {
        currentWeight = 0;
      }

      let urlTo = "/kpi-chart-get-remaining-weight-single-person/";
      let params = {
        'person_id': this.person_id,
        'currentWeight': currentWeight,
        'kpi_incentive_plan_id': this.kpi_incentive_plan_id
      };
      axios.get(urlTo, { params })
        .then((response) => {
          this.remaining_percent_for_complete = response.data;
        });
    },

    openSubmitPopup() {

      this.refreshDeltaWeight();

      Vue.swal.fire({
        title: this.__("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.sureToContinue_title"),
        text: this.__("misc.do_you_want_continue"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.__("misc.yes"),
        cancelButtonText: this.__("misc.back"),
      })
        .then((result) => {

          if (result.isConfirmed) {
            this.shareCheckBeforeSubmit();
          }
        });
      return;


    },

    changeSettingsSegmentation() {

      if (this.typology_choose !== "standard") {
        //reset static goals
        this.segmentation_goals = this.static_goals_array;
        this.typology = this.typology_choose;
      }
      if (this.typology_choose !== "number") {
        this.type_segments = "step";
        this.automatic_percentage_calculation = 0;
      }
      this.setAutomaticDetectionSegmentDirection();
    },
    setConfigStandard() {

      let id = this.standardSegmentationId;
      let standard = this.standard_segmentations.filter(obj => {
        return obj.id == id;
      });
      if (standard.length > 0) {
        let kpiSegmentModel = standard[0];
        this.typology = kpiSegmentModel.typology;
        this.segmentation_direction = kpiSegmentModel.kpi_segment_goal_direction;
        this.automatic_percentage_calculation = kpiSegmentModel.automatic_percentage_calculation;
        this.auto_detect_segmentation_direction = !this.automatic_percentage_calculation;
        this.getStandardGoals(kpiSegmentModel);
      }
    },

    getSegmentationTargetGoal(defaultSegmentation) {
      let urlTo = "/kpi-chart-get-segmentation-target-goal/" + defaultSegmentation + "/kpi_segment";
      axios.get(urlTo)
        .then((response) => {
          this.target = response.data;

        });
    },

    getStandardGoals(kpiSegmentModel) {
      //
      let urlTo = "/kpi-chart-get-segmentation-goals/" + kpiSegmentModel.id + "/kpi_segment";
      axios.get(urlTo)
        .then((response) => {
          this.segmentation_goals = response.data;

        });
    },

    calculateThresholds() {
      axios.post("/calculate-automatic-threshold-kpi-segmentation" + this.userUrl, {
        "segmentation_goals": this.segmentation_goals
      })
        .then((response) => {
          this.segmentation_goals = response.data;
        });
    },

    addRowGoal() {
      let goalRow = {
        'manual_threshold': 0,
        'treshold': 0,
        'percentage': 0,
      };

      this.segmentation_goals.push(goalRow);
    },
    rmRowGoal(index) {
      Vue.delete(this.segmentation_goals, index);
    },

    areThresholdsFilled() {

      let thresholdsFilled = true;

      if (this.automatic_percentage_calculation == 1 || (this.type_segments == 'line' && this.automatic_percentage_calculation == '1')) {
        return thresholdsFilled;
      }


      let field = "manual_threshold";
      if (this.typology === "date") {
        field = "date_manual_threshold";
      }
      if (this.typology === "text") {
        field = "text_manual_threshold";
      }
      for (let index = 0; index < this.segmentation_goals.length; index++) {
        if (this.segmentation_goals[index][field] === undefined || this.segmentation_goals[index][field] === "") {
          thresholdsFilled = false;
        }
      }
      return thresholdsFilled;
    },
    setAutomaticDetectionSegmentDirection() {
      if (this.type_segments == 'line' && this.automatic_percentage_calculation == '1') {
        this.auto_detect_segmentation_direction = false;
      } else {
        this.auto_detect_segmentation_direction = true;
      }
    },
    addTarget() {

      if (this.nameKpi === "" || this.measures_and_formulas === "" ) {
        alert(this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.empty_fields"));
        return;
      }

      if (this.show_unit_measure && (this.unit_measure === "" || this.unit_measure === null) ) {
        alert(this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.empty_unit_measure"));
        return;
      }

      if (this.indicators_available.length > 0 && this.indicator == null) {
        alert(this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.missing_typology"));

        return;
      }

      if (this.required_classification_on_create_kpi && this.classification_id == null) {
        alert(this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.missing_classification"));
        return;
      }

      if (!this.areThresholdsFilled()) {
        alert(this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.missing_thresholds"));
        return;
      }
      if (this.prize_mode == 'weight_percentage' && this.remaining_percent_for_complete < 0) {
        alert(this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.insert_weight_sum_above_100"));
        return;
      }

      if (this.kpi_require_file_on_consumptive == 'kpi_require_file_on_consumptive_choose_on_chart' && (this.kpiRequireFileOnConsumptive == null || this.kpiRequireFileOnConsumptive == '')) {
        alert(this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.you_must_choose_if_kpi_require_attachments_on_consumptive"));
        return;
      }

      this.esg_ids = this.esg_ids.map(item => item.id);

      this.addKpiFormParams = {
        kPI: {
          kpi_group_id: this.kpi_group_id,
          name: this.nameKpi,
          kpi_classification_id: this.classification_id,
          esg_ids: this.esg_ids,
          category_ids: this.category_ids,
          measures_and_formulas: this.measures_and_formulas,
          unit_measure: this.unit_measure,
          target: this.target,
        },
        approve_kpi: this.approve_kpi,
        //If segmentation is the same for alls new KPIS turn off auto_detect_segmentation_direction
        auto_detect_segmentation_direction: (this.segmentation_mode == 1) ? false : this.auto_detect_segmentation_direction,
        segmentation: {
          segmentation_id: this.segmentation_id,
          segmentation_direction: this.segmentation_direction,
          segmentation_goals: this.segmentation_goals,
          automatic_percentage_calculation: this.automatic_percentage_calculation,
          type_segments: this.type_segments,
          segmentation_mode: this.segmentation_mode,
          typology: this.typology,
          standard_segment_id: ((this.standardSegmentationId > 0) ? this.standardSegmentationId : null)
        },
        personKpi: {
          kpi_incentive_plan_id: this.kpi_incentive_plan_id,
          person_id: this.person_id,
          prize_value: this.prize_value,
          indicator: this.indicator,
          approve_kpi: this.approve_kpi,
        },
        prize_mode: this.prize_mode,
        question_survey_id: this.question_survey_id,
        kpiRequireFileOnConsumptive: this.kpiRequireFileOnConsumptive,
      };

      //DETOUR IF SHARE KPI permission is set and kpi_indicator has is_shared flag set
      let indicator_selected = this.indicators_available.find(item => item.slug_name === this.indicator);
      if ((this.permission_share_created_kpi >= 1 && indicator_selected.is_shared_indicator)) {

        this.goToStep2();
        return;
      }
      //Set share_people_kpi for 1 person
      this.addKpiFormParams['share_people_kpi'] = [
        {
          'person_id': this.person_id,
          'prizeValue': this.prize_value
        }
      ];

      this.postRequestStorePeopleKpiTargetChart();
    },

    postRequestStorePeopleKpiTargetChart() {

      axios.post("/store-people-kpi-target-chart" + this.userUrl, this.addKpiFormParams).then((response) => {

        if (response.data == -10) {
          Vue.swal.fire({
            title: this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.max_typology_reached"),
          });
        }
        app.__vue__.$refs.vue_popup.active = false;
        //If targetQuestion is not nested
        if (app.__vue__.$refs["question_target_kpi_chart_" + this.question_survey_id] != null) {
          app.__vue__.$refs["question_target_kpi_chart_" + this.question_survey_id].populateKpiTable();
        }
        else {
          //the targetQuestion maybe is nested in can_enable_question_target_kpi_chart_# ??
          app.__vue__.$refs["can_enable_question_target_kpi_chart_" + this.question_survey_id].
            $refs["question_target_kpi_chart_" + this.question_survey_id].populateKpiTable();
        }

      }).catch(function (error) {

        console.error("error add new KPI " + error);
      });
    },

    kpiShareStorePeople() {

      this.addKpiFormParams['share_people_kpi'] = this.share_people_selected_ids
        .map(person_id => ({
          "person_id": person_id,
          "prizeValue": this.prize_value
        }));


      if (!(this.share_people_selected_ids.filter(item => item !== this.person_id).length)) {

        if (this.permission_share_created_kpi > 2) {
          //Required share with at least 1 beneficiary
          Vue.swal.fire({
            icon: "error",
            title: this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.share_no_people_selected_required")
          });
          return;

        } else {
          //Not required share with beneficiaries, continue?
          Vue.swal.fire({
            title: this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.share_no_people_selected_required"),
            text: this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.share_no_people_selected_are_you_sure"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.__("misc.yes"),
            cancelButtonText: this.__("misc.back"),
          })
            .then((result) => {

              if (result.isConfirmed) {
                this.kpiShareCheckIfWeightsMustSet();
              }
            });
          return;
        }

      }
      this.kpiShareCheckIfWeightsMustSet();

    },

    shareCheckBeforeSubmit() {

      let arePresentNotInsertableAssociation = false;
      this.share_people_selected_weight_array.forEach(item => {

        if (!item.can_be_inserted) {
          arePresentNotInsertableAssociation = true;
        }
      });

      if (arePresentNotInsertableAssociation) {

        Vue.swal.fire({
          title: this.__("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.alertAlreadyPresentSumWeight100_2"),
        });
        return;

      }

      let deltaBelow0 = false;

      //Check deltaBelow0 ( blocking popup )
      this.share_people_selected_weight_array.forEach(item => {

        if (item.remainWeightToAssign < 0) {
          deltaBelow0 = true;
        }
      });

      if (deltaBelow0) {
        Vue.swal.fire({
          title: this.__("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.alertBelow100"),
        });
        return;
      }

      let deltaAbove0 = false;

      //Check deltaAbove0 ( unblocking popup )
      this.share_people_selected_weight_array.forEach(item => {

        if (item.remainWeightToAssign > 0) {
          deltaAbove0 = true;
        }
      });

      if (deltaAbove0) {

        Vue.swal.fire({
          title: this.__("forms.EvaluationChart.questions.questions_setting.question12.addKpiModal.alertAbove100"),
          text: this.__("misc.do_you_want_continue"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.__("misc.yes"),
          cancelButtonText: this.__("misc.back"),
        })
          .then((result) => {

            if (result.isConfirmed) {
              this.postRequestStorePeopleKpiTargetChart();
            }
          });
        return;

      }
      //All sum weights are reaching the 100%, go safe
      this.postRequestStorePeopleKpiTargetChart();

    },

    kpiShareCheckIfWeightsMustSet() {

      //Just for prize_mode "weight_percentage" with no auto_distribution_weights 
      if (this.prize_mode == 'weight_percentage' && !this.auto_distribution_weights) {
        this.goToStep3();
        return;
      }

      this.postRequestStorePeopleKpiTargetChart();
    },
    goToStep2() {
      //Change view of modal
      this.formStep = 2;
      this.page_number_selectable_people = 1;

      //prepare default forms data
      this.share_first_filter_type = null;
      this.kpi_share_second_filter_id = null;

      //ids array
      this.share_people_unselected_ids = [];
      this.share_people_selected_ids = [this.person_id];

      //object arrays with id and fullName
      this.share_people_selected_array = [];
      this.people_unselected_pagination = [];

      this.populateSharePeopleSelectedArray();

      this.share_text_filter = "";
      this.currentPage = 1;
      this.totalPages = 0;

    },

    goToStep3() {

      this.formStep = 3;
      this.getDeltaWeightPercentageTable();
    },

    refreshDeltaWeight() {

      this.getDeltaWeightPercentageTable();
    },

    changeShareKpiMassivePrizeValue() {

      let massiveValue = this.shareKpiMassivePrizeValue;

      this.addKpiFormParams.share_people_kpi.forEach(item => item.prizeValue = massiveValue);

      this.refreshDeltaWeight();
    },

    changeShareKpiPrizeValue(event, person_id) {

      let prizeValue = event.target.value;

      let row = this.addKpiFormParams.share_people_kpi.find(item => item.person_id === person_id);
      if (row) {
        row.prizeValue = prizeValue;
      }

      this.refreshDeltaWeight();
    },

    removeShareKpiPersonAt100(person_id) {

      this.addKpiFormParams.share_people_kpi = this.addKpiFormParams.share_people_kpi
        .filter(item => item.person_id !== person_id);

      this.getDeltaWeightPercentageTable();

    },

    kpiShareStorePeopleWeights() {

      this.postRequestStorePeopleKpiTargetChart();
    },

    getDeltaWeightPercentageTable() {

      let urlTo = "/kpi-chart-share-get-delta-weights-before-submit";
      axios.get(urlTo, {
        params: {
          'addKpiFormParams': this.addKpiFormParams.share_people_kpi,
          'kpi_incentive_plan_id': this.kpi_incentive_plan_id
        }
      })
        .then((response) => {

          this.share_people_selected_weight_array = response.data;

          //show alert already 100 present
          let currentSumWeight100Present = false;
          this.share_people_selected_weight_array.forEach(item => {

            if (!item.can_be_inserted > 0) {
              currentSumWeight100Present = true;
            }
          });

          this.showAlertSumWeight100Present = currentSumWeight100Present;
        });
    },

    resetPaginationPages() {
      //Reset pages
      this.totalPages = 1;
      this.currentPage = 0;
      this.kpiShareGetPeopleFiltered();
    },
    //methods of kpi_share
    kpiShareGetDataForSecondFilter() {

      this.share_people_unselected_ids = [];
      this.shareFlag = true;
      this.kpi_share_second_filter_id = null;

      if (this.share_first_filter_type == '' || this.share_first_filter_type == undefined) {
        return;
      }

      let urlTo = "/kpi-chart-share-get-data-second-filter";
      axios.get(urlTo, { params: { 'first_filter': this.share_first_filter_type } })
        .then((response) => {
          this.share_people_unselected_ids = response.data;
          this.shareFlag = false;
        });
    },
    addAllPageBeneficiaries() {

      if (this.people_unselected_pagination.length < 1) {
        return;
      }

      //I can't use Jquery methods, unless all reference of this.attributes of components will be unreachable     
      for (let i = 0; i < this.people_unselected_pagination.data.length; i++) {
        let row = this.people_unselected_pagination.data[i];
        this.share_people_selected_ids.push(row.id);
      }

      this.kpiShareGetPeopleFiltered();
    },
    removeAllBeneficiaries() {

      this.share_people_selected_ids = [this.person_id];
      this.kpiShareGetPeopleFiltered();
    },
    kpiShareAddSelectedPerson(personId) {

      this.share_people_selected_ids.push(personId);
      this.kpiShareGetPeopleFiltered();
    },
    kpiShareRemovedSelectedPerson(personId) {

      let id_to_remove = parseInt(personId);
      this.share_people_selected_ids = this.share_people_selected_ids
        .map(Number)
        .filter(item => item !== id_to_remove);

      this.kpiShareGetPeopleFiltered();
    },

    kpiShareGetPeopleFiltered() {

      let urlTo = "/kpi-chart-share-get-people-by-filters";
      axios.get(urlTo, {
        params: {
          'page': this.currentPage,
          'first_filter': this.share_first_filter_type,
          'second_filter_id': this.kpi_share_second_filter_id,
          'owner_chart_id': this.person_id,
          'share_people_selected_ids': this.share_people_selected_ids,
          'share_text_filter': this.share_text_filter,
          'kpi_incentive_plan_id': this.kpi_incentive_plan_id,
          'shared_kpi_beneficiary_filter': this.shared_kpi_beneficiary_filter,
        }
      })
        .then((response) => {

          this.people_unselected_pagination = response.data.people_unselected_pagination;
          this.totalPages = this.people_unselected_pagination.last_page;
          this.currentPage = this.people_unselected_pagination.current_page;
          this.populateSharePeopleSelectedArray();
        });
    },

    populateSharePeopleSelectedArray() {


      //converts selected ids from string to int
      this.share_people_selected_array = this.all_people.filter(item =>
        this.share_people_selected_ids.map(Number).includes(item.id)
      )
        //Sort By fullName
        .sort(function (a, b) {
          return a.fullName.localeCompare(b.fullName);
        });

    },

    //PAGINATION
    goToFirstPage() {
      this.currentPage = 1;
      this.kpiShareGetPeopleFiltered();
    },
    goToPreviousPage() {

      this.currentPage = ((this.currentPage - 1) < 1) ? 1 : this.currentPage - 1;
      this.kpiShareGetPeopleFiltered();
    },
    goToNextPage() {
      this.currentPage = ((this.currentPage + 1) > this.totalPages) ? this.totalPages : this.currentPage + 1;
      this.kpiShareGetPeopleFiltered();
    },
    goToLastPage() {

      this.currentPage = (this.totalPages == 0) ? 1 : this.totalPages;
      this.kpiShareGetPeopleFiltered();

    },


  },

}
</script>